module.exports = __webpack_public_path__ + "static/img/img_pc_01.297d3c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_pc_01.png
// module id = 1079
// module chunks = 1